import { SystemStyleObjectRecord } from '@chakra-ui/theme/dist/types/theme.types';

export const LayerStyles: SystemStyleObjectRecord = {};
